import React from 'react';
import { Button, Typography } from '@mui/material';

interface Props {
  error?: string;
}
const ErrorMsg: React.FC<Props> = ({ error }) => {
  return (
    <div style={{ margin: '4em 0', width: '100%' }}>
      <Typography id="error-page-title" variant="h4" align="center" data-cy="error-message">
        {typeof error === 'string' ? error : 'Something went wrong.'}
      </Typography>
      <Typography id="error-page-message" variant="subtitle1" align="center">
        Please try again. If the problem persists, please contact your GLYNT representative.
      </Typography>
      <div
        style={{
          margin: '1em 0',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Button
          onClick={() => window.location.reload()}
          variant="outlined"
          style={{ marginRight: 20 }}
        >
          Reload
        </Button>
      </div>
    </div>
  );
};

export default ErrorMsg;
